export default __webpack_public_path__ + "static/media/team-4.50eda40a.jpeg";